import {EVirtualizedTableCellType} from "../../../VirtualizedTableEnums";
import {FooterKey, LongtextKey, OptionBasicViewKey, ShorttextKey, UspKey} from "../../../../../views/OptionsView/OptionColumns";
import {IVirtualizedTableColumn} from "../../../VirtualizedTableInterfaces";
import {LanguageDto, ModelyearDto, OptionTextDto} from "../../../../../services/Client";
import {IMultiLineValue, lang2flag} from "../../../../MultiLineColumn";
import * as _ from "lodash";
import {ITypefamilyMap} from "../../../../../redux/reducers/generalReducer";

export const OptionIndicatorColumns: IVirtualizedTableColumn[] = [
    {
        key: 'typeFamily',
        label: 'TYPEFAMILY',
        rowType: EVirtualizedTableCellType.TEXTINPUT,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 250,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: 'generation',
        label: 'GENERATION',
        rowType: EVirtualizedTableCellType.TEXTAREA,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 250,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: OptionBasicViewKey,
        label: OptionBasicViewKey.toUpperCase(),
        rowType: EVirtualizedTableCellType.TEXTINPUT,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 250,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: ShorttextKey,
        label: ShorttextKey.toUpperCase(),
        rowType: EVirtualizedTableCellType.TWOLANGUAGETEXTAREA,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 500,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: LongtextKey,
        label: LongtextKey.toUpperCase(),
        rowType: EVirtualizedTableCellType.TWOLANGUAGETEXTAREA,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 500,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: FooterKey,
        label: FooterKey.toUpperCase(),
        rowType: EVirtualizedTableCellType.TWOLANGUAGETEXTAREA,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 200,
            inputWithPopup: false,
            isSortable: false,
        },
    },
    {
        key: UspKey,
        label: UspKey.toUpperCase(),
        rowType: EVirtualizedTableCellType.TWOLANGUAGETEXTAREA,
        options: {
            readOnly: true,
            showOnStart: true,
            cellWidth: 200,
            inputWithPopup: false,
            isSortable: false,
        },
    },
];

export const createMultiLineValues = (texts: OptionTextDto[] | undefined, propName: string, langList: LanguageDto[] | undefined): IMultiLineValue[] => {
    const values: IMultiLineValue[] = [];

    if (texts === undefined || langList === undefined) {
        return values;
    }

    // add multi line values in the order of the sytem languages
    langList.forEach((language: LanguageDto) => {
        // try to find a text in the given language
        const text = _.find(texts, (dto: OptionTextDto) => (
            dto.language !== undefined && dto.language.objectId === language.objectId
        ));
        const textValue = (text && text[propName] !== undefined) ? text[propName] : '';

        values.push({
            caption: language.nameDe,
            text: textValue,
            flag: lang2flag(language.vmce),
        });
    });
    return values;
};

export const extractMultiFields = (texts: IMultiLineValue[]): {} => {
    return texts
        .reduce(
            (result, value) => ({...result,
                [value.flag as string]:
                    {
                        flag: value.flag,
                        value: value.text,
                        originalValues: value
                    }
            }),
            {});
};

export const getTypeFamilyName = (typefamiliyId: number, typefamilyMap: ITypefamilyMap | undefined, modelYear: ModelyearDto): string => {
    const typeFamily = typefamilyMap && typefamilyMap[modelYear.mj1] && typefamilyMap[modelYear.mj1].elements
        ? _.find(typefamilyMap[modelYear.mj1].elements, item => item.objectId === typefamiliyId)
        : undefined;

    return typeFamily ? typeFamily.name : '';
};

export const getUniqueGenerations = (generations: string | undefined): string => {
    if (!generations) {
        return '';
    }
    const uniqueGenerations = generations
        .split(',')
        .map((value: string) => value.trim())
        .filter((value: string) => value.length > 0);

    return _.uniq(uniqueGenerations).join(', ');
};



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/optionIndicator/OptionIndicatorViewUtils.ts